/* eslint-disable no-underscore-dangle */
import { MfaFactor } from '@typescript'

interface MfaFactorLoader {
  (apiResponse?: any, registrationContext?: any): MfaFactor[]
}

/**
 * Loads MFA factors from multiple sources with priority:
 * 1. RegistrationContext if provided
 * 2. Session storage (mfaSetupData) - legacy approach
 * 3. API response _embedded.factors
 * 4. API response mfaFactors
 * 5. Fallback to hardcoded factors
 */
export const loadMfaFactorsFromMultipleSources: MfaFactorLoader = (apiResponse?: any, registrationContext?: any): MfaFactor[] => {
  // Priority 1: Check registrationContext if provided
  if (registrationContext?.mfaFactors && Array.isArray(registrationContext.mfaFactors) && registrationContext.mfaFactors.length > 0) {
    return registrationContext.mfaFactors
  }

  // Priority 2: Check API response for embedded factors
  if (apiResponse?._embedded?.factors && Array.isArray(apiResponse._embedded.factors)) {
    return apiResponse._embedded.factors
  }

  // Priority 3: Check API response for direct mfaFactors
  if (apiResponse?.mfaFactors && Array.isArray(apiResponse.mfaFactors)) {
    return apiResponse.mfaFactors
  }

  return []
}

/**
 * Gets the default/hardcoded MFA factors as fallback
 */
export const getDefaultMfaFactors = (): MfaFactor[] => [
  {
    factorType: 'email',
    factorId: 'email',
    provider: 'OKTA',
    status: 'ACTIVE',
    providerType: 'EMAIL',
  },
  {
    factorType: 'call',
    factorId: 'phone',
    provider: 'OKTA',
    status: 'ACTIVE',
    providerType: 'PHONE',
  },
  {
    factorType: 'sms',
    factorId: 'sms',
    provider: 'OKTA',
    status: 'ACTIVE',
    providerType: 'SMS',
  },
]

/**
 * Loads MFA factors with fallback to defaults
 */
export const loadMfaFactorsWithFallback = (apiResponse?: any, registrationContext?: any): MfaFactor[] => {
  const factors = loadMfaFactorsFromMultipleSources(apiResponse, registrationContext)
  return factors.length > 0 ? factors : getDefaultMfaFactors()
}
